module.exports = __webpack_public_path__ + "img/petstairs16.bc6daa62.jpg";